import {
  ADD_RAISE_TICKET,
  GET_RAISETICKET_DETAIL,
  GET_RAISETICKET_LIST,
  GET_RAISETICKET_USER_LIST,
  REPLY_SUPPORT_TICKET,
  UPDATE_RAISE_TICKET,
  UPDATE_RAISE_TICKET_STATUS,
} from "../types";

const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};

export default function raiseTicketStore(state = initialState, action) {
  switch (action.type) {
    case GET_RAISETICKET_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET_RAISETICKET_DETAIL:
      return {
        ...state,
        detail: true,
        create: false,
        response: action.payload,
      };
    case UPDATE_RAISE_TICKET_STATUS:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
    case UPDATE_RAISE_TICKET:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };
    case REPLY_SUPPORT_TICKET:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        updateTicketresponse: action.payload,
      };
    case ADD_RAISE_TICKET:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    default:
      return state;
  }
}
